import { Grid, Typography } from "@mui/material";
import React from "react";
import { IMaterial } from "../../interfaces";
import { Format } from "../../utils";

export const MaterialInfo: React.FC<{ material: IMaterial }> = ({
    material,
    ...props
}) => {

    return (

        <Grid container>

            {material.partExpiry &&
                <Grid item xs={12}>
                    <Typography className="material-property-text">
                        <strong>Part Expiry</strong>{new Date(material.partExpiry).toLocaleDateString("en-GB")}
                    </Typography>
                </Grid>
            }

            <Grid container columnSpacing={2}>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Site</strong> {material.site?.value}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Warehouse</strong> {material.warehouse?.value ?? "-"}
                    </Typography>

                </Grid>
            </Grid>
            <Grid container columnSpacing={2}>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Rack / Row</strong> {material.rack ?? "-"} / {material.row ?? "-"}
                    </Typography>
                </Grid>

                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Pallet</strong> {material.pallet ?? "-"}
                    </Typography>

                </Grid>
            </Grid>

            <Grid container columnSpacing={2}>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Owned By</strong> {material.ownedBy}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Paperwork Ref</strong> {material.paperWorkReceived ?? "-"}
                    </Typography>
                </Grid>
            </Grid>


            <Grid item xs={12}>
                <Typography className="material-property-text">
                    <strong>Usage Restrictions</strong> {material.hasUsageRestrictions === "Yes" ? material.usageRestrictions : "No"}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Typography className="material-property-text">
                    <strong>Weight per Item</strong>{material.weightEstimate} Kg
                </Typography>
            </Grid>

            <Grid container columnSpacing={2}>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Value Estimate</strong> £{Format.currency(material.valueEstimate)}
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>(Total)</strong> £{Format.currency(material.totalValueEstimate)}
                    </Typography>
                </Grid>
            </Grid>


            {material.valuationOrigin &&
                <Grid item xs={12}>
                    <Typography className="material-property-text">
                        <strong>Valuation Reason / Origin</strong>{material.valuationOrigin}
                    </Typography>
                </Grid>
            }

            {material.notes &&
                <Grid item xs={12}>
                    <Typography className="material-property-text">
                        <strong>Notes</strong>
                        {material.notes.map((x,i) => <div key={i}>{x.note}</div>)}
                    </Typography>
                </Grid>
            }
        </Grid>

    );
}

